// extracted by mini-css-extract-plugin
export default {"page":"_3copE","previous":"_2u9QJ","first":"_9t1b4","next":"_7SNCL","last":"_359ia","active":"z8jxD","large":"_3reNi","arrow":"_3HM8a","inner":"_1zhQU"};